import { render, staticRenderFns } from "./ReportRegister.vue?vue&type=template&id=1f076e9d&scoped=true&"
import script from "./ReportRegister.vue?vue&type=script&lang=js&"
export * from "./ReportRegister.vue?vue&type=script&lang=js&"
import style0 from "./ReportRegister.vue?vue&type=style&index=0&id=1f076e9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f076e9d",
  null
  
)

export default component.exports